import { FolderCopy, FolderCopyOutlined, Topic } from "@mui/icons-material";
import { Card, CardContent, Chip, Grid, LinearProgress, Link, Tooltip } from "@mui/material/";
import { cloneDeep } from "lodash";
import { memo, useContext, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import Api from "../../Api";
import { Feature, PermissionContext } from "../../contexts/PermissionContext";
import { IContract, IContractVariation } from "../../interfaces";
import { EmptyContent } from "./EmptyContent";
import './index.scss';
import { WidgetHeader } from "./WidgetHeader";

export const ContractWidget = memo(() => {

    const permissionContext = useContext(PermissionContext);
    const permitted = () => {
        return permissionContext.isPermitted(Feature.Contract);
    }

    const hasRequests = () => {

        if (!permitted()) return false;

        if (contracts && contracts.length > 0)
            return true;

        if (contractVariations && contractVariations.length > 0)
            return true;

        return false;
    }

    const [contracts, setContracts] = useState<IContract[] | null>(null);
    const [contractVariations, setContractVariations] = useState<IContractVariation[] | null>(null);

    const [dataLoading, setDataLoading] = useState(true);

    const [pending, setPending] = useState(false);

    useEffect(() => {
        if (dataLoading && !pending) {
            setPending(true);

            Api.Contracts.getByStatus("open").then(x => {

                let clist = cloneDeep(x as IContract[]).reverse();

                Api.Contracts.Variation.getByStatus("", "open").then(x => {


                    let cvlist = cloneDeep(x as IContractVariation[]).reverse();
                    setContracts(clist);

                    console.log("GOT CVs", x);


                    setContractVariations(cvlist);
                    setDataLoading(false);
                });

            });


        }
    }, [contracts, contractVariations])



    return (
        <Card elevation={3} className="dashboard-widget dashboard-widget-box">
            <WidgetHeader><Topic sx={{ mr: 1 }} /> Contract / Lease</WidgetHeader>
            <CardContent sx={{ height: "80%", overflowY: "auto", scrollbarWidth: "thin" }}>

                {dataLoading ? <LinearProgress /> :

                    hasRequests() ?
                        <ul className="widget-list">
                            {contracts && contracts.map((c, i) => {
                                return <li key={i}>
                                    <Tooltip title={`${c.reference ?? "No Reference"} (${c.dateCreated && new Date(c.dateCreated).toLocaleDateString("en-GB")})`}>
                                        <Link
                                            component={RouterLink}
                                            to={"/contract/update/" + c.contractId}>
                                            <Grid container justifyContent="space-between">
                                                <span>{c.reference ?? "No Reference"}</span>
                                                <Chip
                                                    label={c.statusName}
                                                    variant="outlined"
                                                    color="primary"
                                                />
                                            </Grid>

                                        </Link>
                                    </Tooltip>
                                </li>
                            })}

                            {contractVariations && contractVariations.map((c, i) => {
                                return <li key={i}>
                                    <Tooltip title={`${c.cvNumber ?? "No Reference"} (${c.dateCreated && new Date(c.dateCreated).toLocaleDateString("en-GB")})`}>
                                        <Link
                                            component={RouterLink}
                                            to={`/contractvariation/update/${c.contract.contractId}/${c.contractVariationId}`}>
                                            <Grid container justifyContent="space-between">
                                                <span> {c.contract.reference ?? ""} <small><FolderCopyOutlined sx={{ ml: 1 }} fontSize="small" /> {c.cvNumber ?? "No CV Number"}</small></span>

                                                <Chip
                                                    label={c.statusName}
                                                    variant="outlined"
                                                    color="primary"
                                                />
                                            </Grid>

                                        </Link>
                                    </Tooltip>
                                </li>
                            })}

                        </ul>
                        :
                        <EmptyContent
                            contentType={"contracts" + (permitted() ? "" : " (You do not have permission to view contracts)")}
                            icon={<Topic fontSize="inherit" />}
                        />
                }

            </CardContent>
        </Card >
    );

});